// Shortens strings to full words without truncating
function shorten(str, maxLength, separator) {
    if (typeof str === "string") {
        if (str.length <= maxLength)
            return str;
        return str.substr(0, str.lastIndexOf(separator, maxLength));
    }
    return str;
}
export default shorten;
//# sourceMappingURL=string-tools.js.map